import { MutationTree } from 'vuex';
import Dashboard, {
  CostBreakdownData,
  DashboardSettings,
  Destination,
  RecentShipment,
  ScheduledPickup,
  Transits,
  Widgets,
  WidgetSettings,
} from '../types';

const mutations: MutationTree<Dashboard> = {
  setWidgets(state: Dashboard, value: Widgets) {
    state.widgets = value;
  },

  setWidgetShow(state: Dashboard, { key, value }: { key: string, value: boolean }) {
    state.widgets[key].show = value;
  },

  updateWidgetSettings(state: Dashboard, setting: WidgetSettings) {
    const {
      dashboardWidget, visible, position, itemsShown, customSettings,
    } = setting;

    state.widgets[dashboardWidget] = {
      ...state.widgets[dashboardWidget],
      show: visible,
      position,
      itemsShown,
      customSettings,
    };
  },

  setDashboardSettings(state: Dashboard, value: DashboardSettings) {
    if (!value) {
      state.isDashboardSettings = 0;
    } else {
      state.dashboardSettings = {
        ...value,
      };

      const setSettingsData = (size: 'big' | 'small') => {
        let position = 1;

        if (!value.order) return;

        value.order[size].forEach((w) => {
          const key = w.charAt(0).toLowerCase() + w.slice(1);
          const currentWidget = state.widgets[key];
          const setting = value.settings?.find((s) => s.dashboardWidget === w);

          state.widgets[key] = {
            ...currentWidget,
            show: true,
            position,
            itemsShown: setting ? setting.itemsShown : 0,
            customSettings: setting ? setting.customSettings : null,
          };

          position += 1;
        });
      };

      setSettingsData('big');
      setSettingsData('small');

      state.isDashboardSettings += 1;
    }
  },

  updateWidgetsPosition(state: Dashboard, widgetNames: string[]) {
    let position = 1;

    widgetNames.forEach((name) => {
      state.widgets[name].position = position;
      position += 1;
    });
  },

  flatPositionsInWidgets(state: Dashboard, size: 'big' | 'small') {
    const widgetElements = Object.entries(state.widgets).map((el) => {
      return {
        ...el[1],
        key: el[0],
      };
    });

    const widgets = widgetElements.filter(
      (widget) => widget.show === true && widget.size === size,
    ).sort((a, b) => {
      return a.position - b.position;
    });

    let position = 1;
    widgets.forEach((widget) => {
      state.widgets[widget.key].position = position;
      position += 1;
    });
  },

  incrementIsDashboardSettings(state: Dashboard) {
    state.isDashboardSettings += 1;
  },

  setShowCustomizeTooltip(state: Dashboard, value: boolean) {
    state.showCustomizeTooltip = value;
  },

  setCustomizeTooltipStep(state: Dashboard, value: number) {
    state.customizeTooltipStep = value;
  },

  setTransitStatus(state: Dashboard, value: Transits) {
    state.widgets.transitStatus.transits = value;
  },

  setRecentShipments(state: Dashboard, value: Array<RecentShipment>) {
    state.widgets.recentShipments.shipments = value;
  },

  setScheduledPickups(state: Dashboard, value: Array<ScheduledPickup>) {
    state.widgets.scheduledPickups.pickups = value;
  },

  setTopDestinations(state: Dashboard, value: Array<Destination>) {
    state.widgets.topDestinations.destinations = value;
  },

  setCostBreakdown(state: Dashboard, value: CostBreakdownData) {
    state.widgets.costBreakdown.data = value;
  },
};

export default mutations;
